if (!customElements.get('multicolumn-slider')) {
  class MulticolumnSlider extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enableSlider !== 'true') return;

      const checkSwiper = setInterval(() => {
        if (typeof FoxTheme !== 'undefined' && FoxTheme.Carousel) {
          clearInterval(checkSwiper);
          this.initSlider();
        }
      }, 50);

      document.addEventListener('shopify:section:load', (e) => {
        if (e.detail.sectionId === this.closest('.section').dataset.id) {
          this.destroySlider();
          this.initSlider();
        }
      });

      document.addEventListener('shopify:block:select', (e) => {
        if (e.detail.sectionId === this.closest('.section').dataset.id) {
          this.swiper?.update();
        }
      });
    }

    destroySlider() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    initSlider() {
      if (typeof FoxTheme === 'undefined' || !FoxTheme.Carousel) return;

      const desktopItems = parseInt(this.dataset.items) || 4;
      const tabletItems = parseInt(this.dataset.tabletItems) || 3;
      const mobileItems = parseInt(this.dataset.mobileItems) || 1;

      const parent = this.closest('.section__content');
      const sectionId = this.dataset.sectionId;

      const sliderOptions = {
        wrapperClass: `swiper-wrapper-${sectionId}`,
        slideClass: `swiper-slide-${sectionId}`,
        slidesPerView: mobileItems,
        spaceBetween: 16,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,

        navigation: {
          nextEl: parent.querySelector('.swiper-button-next'),
          prevEl: parent.querySelector('.swiper-button-prev'),
        },

        pagination: {
          el: parent.querySelector('.swiper-pagination'),
          clickable: true,
        },

        breakpoints: {
          768: {
            slidesPerView: tabletItems,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: desktopItems,
            spaceBetween: 24,
          },
        },

        on: {
          progress: (swiper) => {
            this.dispatchEvent(new CustomEvent('swiper:change', { detail: { swiper }, bubbles: true }));
          },
          resize: (swiper) => {
            swiper.update();
            this.dispatchEvent(new CustomEvent('swiper:change', { detail: { swiper }, bubbles: true }));
          },
        },
      };

      this.carousel = new FoxTheme.Carousel(this, sliderOptions);
      this.carousel.init();
      this.swiper = this.carousel.slider;

      this.dispatchEvent(new CustomEvent('swiper:init', { detail: { swiper: this.swiper }, bubbles: true }));
    }
  }

  customElements.define('multicolumn-slider', MulticolumnSlider);
}
